




















































































































import Vue from 'vue'
import Component from 'vue-class-component'

import PostApi from '../includes/logic/Api/PostApi'

@Component
export default class LoyaltySystem extends Vue {
  bonusRules = null

  bonusBillCurrencySymbol = null

  get partnerLink(): string {
    return this.$store.state.AdminTemplate.applicationConfig.loyaltySystem?.partnerBlock.partnerLink(this.$i18n.locale)
  }

  get termsOwnerLink(): string {
    return this.$store.state.AdminTemplate.applicationConfig.loyaltySystem?.companiesBlock.termsOwnerLink(this.$i18n.locale)
  }

  async created(): Promise<void> {
    try {
      const { data } = await PostApi.sendRequest('tg', 'getbonusinfo')
      this.bonusRules = data.bonus_rules.map((rule:any, index:number) => ({ index, ...rule }))
      this.bonusBillCurrencySymbol = data.currency_symbol
    } catch (error: any) {
      console.log(error)
    }
  }
}
